import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subjective-test-submit-feedback',
  templateUrl: './subjective-test-submit-feedback.component.html',
  styleUrls: ['./subjective-test-submit-feedback.component.css']
})
export class SubjectiveTestSubmitFeedbackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
